import { shikiToMonaco } from '@shikijs/monaco'
import * as monaco from 'monaco-editor'

import {
  type FPlusHighlighterProps,
  getFPlusHighlighter,
} from './fplusHighlighter'

/**
 * Makes Shiki drive Monaco's F-plus highlighting: it defines the F-plus themes
 * and installs a TextMate tokens provider for the language id the grammar is
 * loaded under.
 *
 * The languages must already be registered, and no editor may have been created
 * yet, because `shikiToMonaco` patches `editor.setTheme` and `editor.create`.
 */
export async function setupFPlusHighlighting(props: FPlusHighlighterProps) {
  const highlighter = await getFPlusHighlighter(props)

  shikiToMonaco(highlighter, monaco)
}
